import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type AccountTfnSubmittedProps = EventProps

/**
 * @event tfn_submitted
 * @description Emitted when a user successfully submits their TFN from the account settings TFN form.
 */
export const AccountTfnSubmittedAnalytics = createAnalyticsStatic<AccountTfnSubmittedProps>(
    ANALYTICS_EVENTS.ACCOUNT.TFN_SUBMITTED,
)

export default AccountTfnSubmittedAnalytics
